import React, { Component } from 'react'
import Helmet from 'react-helmet'

import Link from 'gatsby-link'
import Img from 'gatsby-image'

import './agenda.sass'
import ArrowIcon from '../components/svgs/arrow-right'

export default class AgendaPage extends Component {
  componentDidMount() {
    if (window) {
      window.dispatchEvent(new Event('scroll'))
    }
  }

  render() {
    const eventiFuturi = this.props.data.allDatoCmsEventoFuturo.edges
      .map(edge => ({
        title: edge.node.titolo,
        date: edge.node.data,
        path: edge.node.fields.path,
        imageUrl: edge.node.immagine ? edge.node.immagine.url : undefined,
        imageFluid: edge.node.immagine ? edge.node.immagine.fluid : undefined,
      }))
      .filter(evento => evento.title.toLowerCase().indexOf('non toccare') < 0)

    const eventiPassati = this.props.data.allDatoCmsEventoPassato.edges
      .map(edge => ({
        title: edge.node.titolo,
        date: edge.node.data,
        path: edge.node.fields.path,
      }))
      .filter(evento => evento.title.toLowerCase().indexOf('non toccare') < 0)

    const attivitaDeiRicercatori = this.props.data.allDatoCmsAttivitaDeiRicercatori.edges
      .map(edge => ({
        title: edge.node.titolo,
        date: edge.node.data,
        path: edge.node.fields.path,
      }))
      .filter(evento => evento.title.toLowerCase().indexOf('non toccare') < 0)

    const { data } = this.props

    return (
      <div className="wrap-narrower">
        <Helmet>
          <title>Agenda | {data.site.siteMetadata.title}</title>
        </Helmet>

        {/* Eventi futuri */}

        <h1 className="text-primary">Eventi futuri</h1>

        <div className="Eventi__Grid">
          {eventiFuturi.map((event, i) => (
            <Link
              to={event.path}
              className="Eventi__GridItem with-arrow-icon"
              key={i}
            >
              {event.imageFluid && (
                <div className="Eventi__GridItem__Image">
                  <Img
                    fluid={event.imageFluid}
                    style={{
                      position: 'absolute',
                      left: 0,
                      top: 0,
                      width: '100%',
                      height: '100%',
                    }}
                  />
                </div>
              )}
              <div className="Eventi__GridItem__Title text-bold">
                {event.title}
              </div>
              <div className="Eventi__GridItem__Description text-bold">
                {event.date}
              </div>
              <div className="mt-1">
                <ArrowIcon />
              </div>
            </Link>
          ))}
        </div>

        {/* Attività dei ricercatori */}

        <h1 className="text-primary">Attività dei ricercatori</h1>

        <div className="Eventi__Grid">
          {attivitaDeiRicercatori.map((event, i) => (
            <Link
              to={event.path}
              className="Eventi__GridItem with-arrow-icon"
              key={i}
            >
              <div className="Eventi__GridItem__Title text-bold">
                {event.title}
              </div>
              <div className="Eventi__GridItem__Description text-bold">
                {event.date}
              </div>
              <div className="mt-1">
                <ArrowIcon />
              </div>
            </Link>
          ))}
        </div>

        {/* Eventi passati */}

        <h1 className="text-primary">Eventi passati</h1>

        <div className="Eventi__Grid">
          {eventiPassati.map((event, i) => (
            <Link
              to={event.path}
              className="Eventi__GridItem with-arrow-icon"
              key={i}
            >
              <div className="Eventi__GridItem__Title text-bold">
                {event.title}
              </div>
              <div className="Eventi__GridItem__Description text-bold">
                {event.date}
              </div>
              <div className="mt-1">
                <ArrowIcon />
              </div>
            </Link>
          ))}
        </div>
      </div>
    )
  }
}

export const query = graphql`
  query Agenda {
    site {
      siteMetadata {
        title
      }
    }
    allDatoCmsEventoFuturo {
      edges {
        node {
          titolo
          data
          fields {
            path
          }
          immagine {
            url
            fluid(maxWidth: 600, imgixParams: { fm: "jpg", auto: "compress" }) {
              base64
              aspectRatio
              src
              srcSet
              sizes
            }
          }
        }
      }
    }
    allDatoCmsEventoPassato {
      edges {
        node {
          titolo
          data
          fields {
            path
          }
        }
      }
    }
    allDatoCmsAttivitaDeiRicercatori {
      edges {
        node {
          titolo
          data
          fields {
            path
          }
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/agenda.js